module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_myplof-3ba83fac76d958903dff1f3b932c9d97.png";